import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

import ACLStore from "lib/aclStore";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import EmptyField from "UIComponents/EmptyField";
import {
  generateNestedSelectedData,
  getPYPElementSetFromNodes,
  getTopParent,
  mergeDeep,
} from "Utils";
import Groupedview from "./Groupedview";

import UIBaseComponent from "UIComponents/UIBaseComponent";
import Levels from "MultiLevelNodeEditor/routes/Levels/components";
import classes from "./NestedSelectComponent.scss";
import { plannerElementsUnitPlanPropsMemoize } from "NodeEditor/Utils";
import { CURRICULUM_TYPE_MYP } from "Constants/stringConstants";
import { ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION } from "Constants/permissionConstants";
import { DSProvider } from "@toddle-edu/ds-web";

const generateNestedSelectedDataMemoize = _.memoize(
  ({ nodes, value }) => {
    return generateNestedSelectedData({
      ...getPYPElementSetFromNodes({ nodes }),
      value,
    });
  },
  params => JSON.stringify(params)
);

class NestedSelectComponent extends UIBaseComponent {
  constructor(props) {
    super(props);
    if (props.customRef) {
      props.customRef(this);
    }
    this.state = {
      ...this.state,
      openSelectionModal: false,
      parentNode: {},
      modalState: "",
    };
  }

  blur = ({ field }) => {
    const { uid, id } = field;
    const { parentNode } = this.state;
    if (parentNode.id == id) {
      this.onSelectionModalCancelClicked();
    }
  };

  onAddNewClicked = parentNode => {
    this.setState({
      openSelectionModal: !this.state.openSelectionModal,
      modalState: "add",
      parentNode: parentNode,
    });
  };

  componentDidMount = () => {
    const { parentNodes, isCourseOverview, parentNodeId } = this.props;
    if (isCourseOverview) {
      this.setState({
        openSelectionModal: true,
        modalState: "edit",
        parentNode:
          _.find(parentNodes, { id: parentNodeId }) ?? _.first(parentNodes),
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { onBlurInputField, onFocusInputField } = this.props;
    const { parentNode } = this.state;
    const { parentNode: prevparentNode } = prevState;
    if (prevState.openSelectionModal != this.state.openSelectionModal) {
      if (this.state.openSelectionModal) {
        // onFocusInputField({ others: { id: parentNode.id } });
      } else {
        // onBlurInputField({ others: { id: prevparentNode.id } });
      }
    }
  };

  onEditClicked = parentNode => {
    this.setState({
      openSelectionModal: !this.state.openSelectionModal,
      modalState: "edit",
      parentNode: parentNode,
    });
  };

  isValidValue = () => {
    const { nodes } = this.props;
    return !_.isEmpty(nodes);
  };

  onSubmitClicked = result => {
    const {
      plannerElementSetData,
      isCourseOverview,
      onBackClick = _.noop,
    } = this.props;
    const { parentNode } = this.state;
    const value = this.props.value ? _.cloneDeep(this.props.value) : [];
    const updatedValue = _.uniq([
      ..._.filter(
        value,
        id =>
          !_.includes(
            _.map(result.nodes, item => item.id),
            id
          )
      ),
      ...(result.selections || []),
    ]);
    const { valuesToAdd, valuesToRemove, shouldCloseModal } = result;
    if (shouldCloseModal) {
      this.setState({
        openSelectionModal: !this.state.openSelectionModal,
        parentNode: {},
      });

      // close the parent modal from course overview too on exit
      if (isCourseOverview) {
        onBackClick?.();
      }
    }

    //TODO: Chaitu why is settimeout needed here?
    setTimeout(() => {
      this.updateValue(updatedValue, {
        nodes: _.filter(result.nodes, node => !node.isDummy),
        rootNodeId: parentNode.id,
        rootNodeKey: plannerElementSetData.type,
        valuesToAdd,
        valuesToRemove,
      });
    });
  };

  onSelectionModalCancelClicked = () => {
    const { onBackClick } = this.props;

    this.setState({
      openSelectionModal: !this.state.openSelectionModal,
      parentNode: {},
    });

    onBackClick?.();
  };

  onEditClick = () => {
    const { parentNodes } = this.props;
    this.onEditClicked(_.first(parentNodes));
  };

  renderOptions = () => {
    const {
      props: {
        parentNodes,
        value,
        nodes,
        fieldLockedObject,
        plannerLabel = "",
        emptyTextSelectSubgroupLocale,
        plannerElementSetData,
        showEditButtonAtHeader,
        groupedViewConfig,
        lockFieldForSchoolGroups,
        mode,
      },
    } = this;
    const { lockedDynamicFields } = fieldLockedObject;

    const nestedValue = generateNestedSelectedDataMemoize({
      value,
      nodes,
    });

    const rootNodeIds = [];

    return (
      <div className={classes.subjectBenchMarkContainer}>
        {_.map(parentNodes, (parentNode, index) => {
          let nestedGroupedValue = nestedValue;
          let filteredRootNodeIds = rootNodeIds;

          //Handled for Objectives and ATLS. Not handled for Interdisciplinary Criteria
          if (!_.isNil(plannerElementSetData.groupedByType)) {
            //Handled for Objectives in which they are groupedBy subject groups
            if (
              plannerElementSetData.type != plannerElementSetData.groupedByType
            ) {
              nestedGroupedValue = _.filter(nestedValue, node =>
                _.find(node.associatedParents, { id: parentNode.id })
              );
              filteredRootNodeIds = _.filter(rootNodeIds, node =>
                _.find(node.associatedParents, { id: parentNode.id })
              );
            }
            //Handled for ATLS in which they are groupedBy ATL root nodes
            else if (!parentNode.isDummy) {
              nestedGroupedValue = _.get(
                _.find(nestedValue, {
                  id: parentNode.id,
                }),
                "children",
                []
              );
              filteredRootNodeIds = _.get(
                _.find(rootNodeIds, { id: parentNode.id }),
                "children",
                []
              );
            }
          }

          const lockedField = _.find(lockedDynamicFields, {
            id: parentNode.id,
          });

          let rootNodeDepth = _.get(
            _.first(_.orderBy(nodes, "depth")),
            "depth",
            1
          );
          if (!_.isNil(_.get(parentNode, "depth", null))) {
            rootNodeDepth = _.get(parentNode, "depth", 0) + 1;
          }
          return (
            <Groupedview
              key={parentNode.id}
              parentNode={parentNode}
              emptyTextSelectSubgroupLocale={emptyTextSelectSubgroupLocale}
              plannerLabel={plannerLabel}
              nestedGroupedValue={nestedGroupedValue}
              onAddNewClicked={this.onAddNewClicked}
              lockedField={lockedField}
              lockFieldForSchoolGroups={lockFieldForSchoolGroups}
              onAddClicked={this.onEditClicked}
              showEditButtonAtHeader={showEditButtonAtHeader}
              rootNodeDepth={rootNodeDepth}
              {...groupedViewConfig}
              nodes={nodes}
              rootNodeIds={_.map(filteredRootNodeIds, "id")}
              mode={mode}
            />
          );
        })}
      </div>
    );
  };

  renderModal = () => {
    const {
      state: { parentNode, openSelectionModal },
      props: {
        value,
        nodes,
        plannerElementSetData,
        t,
        label,
        emptyTextAddSubgroupLocale,
        multiSelectConfig,
        nodeRenderType,
        curriculumType,
        dummyRootNode,
        isMYPObjectivePhasesEnabled,
      },
    } = this;
    let filteredNodes = [];
    let filteredValue = value;
    let filters = {};
    if (!_.isNil(plannerElementSetData.groupedByType)) {
      //Handled for Objectives in which they are groupedBy subject groups
      if (plannerElementSetData.type != plannerElementSetData.groupedByType) {
        filteredNodes = _.filter(
          nodes,
          nodeItem =>
            !!_.find(nodeItem.associatedParents, { id: parentNode.id })
        );

        filteredValue = _.filter(
          value,
          val => !!_.find(filteredNodes, { id: val })
        );
        filters = {
          associatedParents: [
            { ids: [parentNode.id], type: plannerElementSetData.groupedByType },
          ],
        };
        if (isMYPObjectivePhasesEnabled && parentNode.selectedObjectiveIds) {
          filters = {
            ...filters,
            parentNodes: parentNode.selectedObjectiveIds,
          };
        }
      }
      //Handled for ATLS in which they are groupedBy ATL root nodes
      else if (!parentNode.isDummy) {
        filteredValue = _.filter(value, val => {
          const topParent = getTopParent({ nodeId: val, nodes });
          return topParent == parentNode.id;
        });

        filters = {
          parentNodes: [parentNode.id],
        };
      }
    }
    //Handled for Interdisciplinary Criteria in which they are groupedBy ATL root nodes
    if (plannerElementSetData.subType) {
      filters = { ...filters, subTypes: [plannerElementSetData.subType] };
    }

    //Merge filter with prop filters
    if (!_.isNil(plannerElementSetData.filters)) {
      filters = mergeDeep(plannerElementSetData.filters, filters);
    }

    const rootNode = {
      ...parentNode,
      subject: parentNode.isDummy ? null : parentNode.id,
    };

    const newNodeEditorProps = plannerElementsUnitPlanPropsMemoize({
      filters,
      nodes: _.filter(nodes, node => _.includes(filteredValue, node.id)),
      parentNode,
      curriculumType,
      plannerElementType: plannerElementSetData.type,
    });
    return (
      openSelectionModal && (
        <UIModal
          isOpen={true}
          overlayContainer={classes.overlayContainer}
          isFullScreen={true}
        >
          <DSProvider dsVersion="1.0">
            <Levels
              label={label}
              updateValueLocally={this.updateValueLocally}
              value={filteredValue}
              emptyText={t(emptyTextAddSubgroupLocale, {
                label: parentNode.label,
              })}
              isTagging={true}
              rootNode={rootNode}
              mode={"view"}
              nodeType={plannerElementSetData.type}
              nodeParentType={plannerElementSetData.parentType}
              plannerElementSetConfig={{ ...plannerElementSetData, filters }}
              onBackClick={this.onSelectionModalCancelClicked}
              onSubmitClick={this.onSubmitClicked}
              showSearchHeader={false}
              multiSelectConfig={multiSelectConfig}
              nodeRenderType={nodeRenderType}
              // following props required for new SNS editor
              {...newNodeEditorProps}
              dummyRootNode={dummyRootNode}
            />
          </DSProvider>
        </UIModal>
      )
    );
  };

  shouldShowEditEmpty = () => {
    const {
      props: { parentNodes, isMYPObjectivePhasesEnabled },
    } = this;

    // if objectives selection is not restricted, check only that we have nodes to display or not
    if (!isMYPObjectivePhasesEnabled) return _.isEmpty(parentNodes);

    // else if no objective level is selected for the subject user should not be able to select the objectives
    const selectedObjectiveIds = _.get(
      _.first(parentNodes),
      "selectedObjectiveIds",
      []
    );
    return (
      _.isEmpty(parentNodes) ||
      (_.has(_.first(parentNodes), "selectedObjectiveIds") &&
        _.isEmpty(selectedObjectiveIds))
    );
  };

  renderEditEmpty = () => {
    const { t, emptyTextLocale, plannerLabel } = this.props;
    return <EmptyField title={t(emptyTextLocale, { plannerLabel })} />;
  };

  renderEdit = () => {
    return (
      <div className={classes.container}>
        {this.renderOptions()}
        {this.renderModal()}
      </div>
    );
  };

  renderView = () => {
    return this.renderOptions();
  };
}

const mapActionCreators = {};

/*

    plannerElementSetData:{
      type: oneOf(['MYP_ATL', 'MYP_OBJECTIVES','MYP_LEARNING_STANDARD']),
      parentType: oneOf(['PLANNER_ELEMENT','SUBJECT_GROUP','SUBJECT']),
      groupedByType: oneOf(['MYP_ATL', 'SUBJECT_GROUP','SUBJECT'])
    }

    //Those nodes on which you want to group
    parentNodes :[{id:"1",label:"Mathematics"},{id:"2",label:"Science"}]


  */
const mapStateToProps = (state, ownProps) => {
  const plannerElementSetData =
    _.get(ownProps, "options.plannerElementSetData", []) || {};
  const plannerLabel = _.get(ownProps, "plannerLabel", ownProps.label);

  const curriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const isMYPObjectivePhasesEnabled = _.isEqual(
    curriculumType,
    CURRICULUM_TYPE_MYP
  )
    ? !ACLStore.can("FeatureFlag:RemoveMYPObjectivesPhase") ||
      ACLStore.can(ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION)
    : true;

  return {
    nodes: _.get(ownProps.resolvedValue, "nodes", []),
    parentNodes: _.get(ownProps, "options.parentNodes", []) || [],
    dummyRootNode: _.get(ownProps, "options.dummyRootNode", []) || [],
    plannerLabel,
    plannerElementSetData,
    isMYPObjectivePhasesEnabled,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: "unitPlan" })
)(NestedSelectComponent);

//Need Review @kunal
